import type { Event } from '@mattoespresso/brew-firestore';

import { useContext, createContext } from 'react';

import { useCollectionData } from 'src/hooks/useCollectionData';

import { COLLECTIONS } from 'src/lib/consts';

const EventsContext = createContext<{
  data: Event[];
  loading: boolean;
  error: any;
}>({
  data: [],
  loading: false,
  error: null,
});

export function useEvents() {
  return useContext(EventsContext);
}

export function EventsProvider({ children }: { children: React.ReactNode }) {
  const value = useCollectionData<Event>({ collectionName: COLLECTIONS.matto_events });

  return <EventsContext.Provider value={value}>{children}</EventsContext.Provider>;
}
